import { createFileRoute } from '@tanstack/react-router'

import EditApbnApbdPage from '@/components/pages/backoffice/_ktg-penyuluh/apbn-apbd/$apbnApbd/_edit/containers/EditApbnApbdPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/apbn/$apbnId/edit/'
)({
  component: RouteComponent
})

function RouteComponent() {
  const id = Route.useParams().apbnId
  return <EditApbnApbdPage type="APBN" id={id} />
}
